(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('footerCarousel', function($timeout, $q) {
    return {
        restrict: 'A',
        transclude: true,
        link(scope, element, attributes, controller, $transclude) {
            const $element = $(element);
            let carousel = false;

            function processItem(item) {
                const deferred = $q.defer();

                $transclude(function(clone, scope) {
                    scope.item = item;
                    deferred.resolve($element.append(clone));
                });

                return deferred.promise;
            }

            scope.$watchCollection(attributes.footerCarousel, function(elem) {
                //ensure this only runs when the section is open
                if (!elem.open) {
                    return;
                }

                if (carousel) {
                    $element.slick('unslick');
                    carousel = false;
                }
                $element.empty();

                const filteredThings = elem.things.filter(hotel => !hotel.deleted);

                if (!filteredThings.length) {
                    return;
                }

                $q.all(filteredThings.map(processItem)).then(function() {
                    $timeout(function() {
                        $element.slick({
                            rtl: TRPCONFIG.Rtl,
                            prevArrow: $element.siblings('.slick-prev'),
                            nextArrow: $element.siblings('.slick-next'),
                            infinite: false,
                            slidesToShow: 5,
                            slidesToScroll: 1,
                            swipeToSlide: true,
                            variableWidth: true,
                            responsive: [{
                                breakpoint: 1760,
                                settings: {
                                    slidesToShow: 4
                                }
                            }, {
                                breakpoint: 1425,
                                settings: {
                                    slidesToShow: 3
                                }
                            }, {
                                breakpoint: 1000,
                                settings: {
                                    slidesToShow: 2
                                }
                            }]
                        });
                        carousel = true;

                        //turn off all new flags to reveal added element
                        filteredThings.forEach(thing => thing.new = false);
                        scope.$apply();
                    }, 200);
                });
            });
        }
    };
});
})();
